import React from 'react';
import { Avatar, Flex } from '@mss/mss-component-library';
import { Dropdown, Menu } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisV } from '@fortawesome/free-solid-svg-icons';
import DeleteGroupModal from '../Delete/Modal';
import type { TFunction } from 'i18next';
import isSuperAdmin from 'jsx/authorization/util/isSystemGroup';
import { AuthorizationGroup } from 'jsx/@types/authorization';
import { QueryClient } from '@tanstack/react-query';

export default function GroupColumns(
  hasPermission: (x: string | string[]) => boolean,
  queryClient: QueryClient,
  t: TFunction
) {
  return [
    {
      title: '',
      dataIndex: 'name',
      key: 'name',
      width: 30,
      render: (a: any, record: any) => (
        <Flex h="center" v="center">
          <Avatar
            firstName={record.name[0]}
            lastName={record.name[record.name.length - 1]}
          />
        </Flex>
      ),
    },
    {
      title: t('Name'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: '',
      render: (record: AuthorizationGroup) => (
        <div
          onClick={e => e.stopPropagation()}
          style={{ width: 30, textAlign: 'center' }}
        >
          {hasPermission(['delete_group']) && !isSuperAdmin(record) && (
            <Dropdown
              overlay={
                <Menu>
                  {hasPermission('delete_group') && (
                    <Menu.Item
                      onClick={() => {
                        DeleteGroupModal(record, t, queryClient);
                      }}
                    >
                      {t('Delete')}
                    </Menu.Item>
                  )}
                </Menu>
              }
              trigger={['click']}
            >
              <div style={{ width: 24 }}>
                <FontAwesomeIcon icon={faEllipsisV} />
              </div>
            </Dropdown>
          )}
        </div>
      ),
      width: 40,
    },
  ];
}
